import { createActions } from 'redux-actions';

const {
  // getUser,
  getUserSuccess,
  getUserFailure,
  authUpdateProfileInfo,
} = createActions(
  'GET_USER',
  'GET_USER_SUCCESS',
  'GET_USER_FAILURE',
  'AUTH_UPDATE_PROFILE_INFO'
);
export {
  // getUser,
  getUserSuccess,
  getUserFailure,
  authUpdateProfileInfo,
};
